import { CourseSchedule } from "src/app/models/course-schedule";
import { ApprovedTrainingProviderCoursesModel } from "../approved-training-provider-courses.model";
import { AddressMapper } from "./address.mapper";


export class ApprovedTrainingProviderCoursesMapper {

    public static map(x: any): ApprovedTrainingProviderCoursesModel {
        return {TrainingProvider: x.TrainingProvider, RegisteredAddress: AddressMapper.map([x.RegisteredAddress])[0], ElectronicAddresses: x.ElectronicAddresses, DeliveryMethodsOffered: x.DeliveryMethodsOffered, CourseApprovals: x.CourseApprovals}
    }

    public static mapArray(x: any[]): ApprovedTrainingProviderCoursesModel[] {
        let approvedTrainingProviderCourses: ApprovedTrainingProviderCoursesModel[] = [];
        x.forEach(x => {
            approvedTrainingProviderCourses.push({TrainingProvider: x.TrainingProvider, RegisteredAddress: AddressMapper.map([x.RegisteredAddress])[0], 
                ElectronicAddresses: x.ElectronicAddresses, DeliveryMethodsOffered: x.DeliveryMethodsOffered, CourseApprovals: x.CourseApprovals});
        })
        return approvedTrainingProviderCourses;//{TrainingProvider: x.TrainingProvider, RegisteredAddress: AddressMapper.map([x.RegisteredAddress])[0], ElectronicAddresses: x.ElectronicAddresses, DeliveryMethodsOffered: x.DeliveryMethodsOffered, CourseApprovals: x.CourseApprovals}
    }
}
